module.exports = __webpack_public_path__ + "img/fortran_book_cover.df49b46c.jpeg";